// Пока что используется как участник команды
import { EVENT_USER_STATUS, EVENT_USER_STATUS_DATA } from '@/modules/Events/constants';

import CertificateProfile from './certificate-profile';

export default class Member {
  constructor(member) {
    this.id = member.id;
    this.role_id = member.role_id || null;
    this.roles = member.roles || [];
    this.username = member.username;

    this.status = EVENT_USER_STATUS_DATA[member.status || EVENT_USER_STATUS.STATUS_REQUEST];

    this.certificate = member.certificate || {};
    this.directory_attributes = member.directory_attributes || [];

    this.profile = this.setProfile(member.profile);

    if (typeof member.is_captain === 'boolean') this.is_captain = member.is_captain;
  }

  setProfile(profile) {
    this.profile = profile ? new CertificateProfile(profile) : null;
  }
}
